module.exports = __webpack_public_path__ + "media/img/pages/profile/lidl ger 2-fbf42eab042fcf982c31d8ca14b4a325.jpg";